import axios from 'axios'
import { toast } from 'react-toastify'
import config from '../config/environment'

const api = axios.create({
  baseURL: config.ADMIN_API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true,
})

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      window.location.href = '/admin/login'
    }
    return Promise.reject(error)
  }
)

export const contactLeadAdminService = {
  /**
   * @param {{ page?: number, limit?: number, search?: string }} params
   * @returns {Promise<{ success: boolean, data?: { contact_leads: Array, pagination: object }, message?: string }>}
   */
  async listContactLeads(params = {}) {
    try {
      const response = await api.get('/contact-leads', { params })
      return response.data
    } catch (error) {
      const errorMessage = error.response?.data?.message || 'Failed to load contact leads'
      toast.error(errorMessage)
      throw new Error(errorMessage)
    }
  },
}

export default contactLeadAdminService
